module.exports = __webpack_public_path__ + "static/media/image-6.a1015e69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/StateofSocial/image-6.jpg
// module id = 485
// module chunks = 0